<script lang="ts">
	import { format } from 'src/services/i18n';
	import { Button, Container, Alert, Text } from '@Shelly/shelly-design-system';
	import type { Device } from 'src/types/Device';
	import { isWallDisplay } from 'src/helpers/interface_helpers';
	import { update } from 'src/stores/ui/edit_lists';
	import { user_data } from 'src/stores/account/user';
	import BatchTransferModal from 'src/components/BatchCommandModals/BatchTransferModal.svelte';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';

	export let device: Device;

	let showTransferModal = false;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);
	/** Whether the device itself is eligible for transfer, ignoring the shared-home gate. */
	$: deviceTransferable =
		!device.shared &&
		!device.shared_by_me &&
		!device.id.includes('_') &&
		!isWallDisplay(device.type) &&
		!is_loqed(device) &&
		!$user_data?.installer;
	$: canTransfer = !isSharedHomeActive && deviceTransferable;

	const onTransferClick = () => {
		update.update(() => ({
			value: true,
			subType: '',
			selectAll: false,
			type: 'account_transfer_devices',
			selectedDevices: { [device.id]: device } as any,
		}));
		showTransferModal = true;
	};
</script>

<Container type="borderSolid" backgroundColor="color-base">
	{#if canTransfer}
		<Alert
			class="mb-s"
			type="info"
			heading={$format('transfer_device_description_new', {
				default:
					'Transfer this device to another account, or move it to one of your other homes.',
			})}
		/>
		<Button
			class="width-sm-full"
			variant="primary"
			size="m"
			responsiveSize={{ sm: 'm' }}
			on:click={onTransferClick}
		>
			{$format('button_transfer', { default: 'Transfer' })}
		</Button>
	{:else if isSharedHomeActive && deviceTransferable}
		<SharedHomeOwnerManagedAlert class="mb-s" context="transfer_device" />
		<Button class="width-sm-full" variant="primary" size="m" responsiveSize={{ sm: 'm' }} disabled>
			{$format('button_transfer', { default: 'Transfer' })}
		</Button>
	{:else}
		<Text styleType="body-small" class="text-secondary">
			{$format('transfer_device_not_available', {
				default: 'Transfer is not available for this device.',
			})}
		</Text>
	{/if}
</Container>

{#if showTransferModal}
	<BatchTransferModal bind:showModal={showTransferModal} areFiltersDisabled={false} />
{/if}
